<template>
    <input
        :class="[
        styles.input,
        { 'border-red-500 hover:border-red-500 focus:border-red-600 text-red-600': hasErrors }
        ]"
        :value="value"
        @keyup.stop="$root.productType !== undefined ? $root.stopArrows($event): ''"
        @[eventName]="$emit('input', $event.target.value)"
    />
</template>

<script>

export default {
  name: 'BaseInput',
  props: {
    hasErrors: {
      type: Boolean,
      default: false
    },

    value: {
      type: [String, Number, Boolean],
      required: true
    },

    eventName: {
      default: 'input',
      validator (value) {
        return ['change', 'input'].includes(value)
      }
    }
  },

  emits: ['input'],
  data () {
    return {
      styles: window.myStyles
    }
  }
}
</script>

<style scoped>

</style>
